export default "__VITE_ASSET__65647ccf__"